module.exports = __webpack_public_path__ + "static/img/img_orderDetail.434dc556.png";